<div class="form-panel-container">
    <form [formGroup]="formGroup">
        <div class="form-container" [ngClass]="{ readonly: _context?.mode === FormMode.Reading }">
            <div class="form-item form-item-help">
                <mat-form-field class="with-info-icon">
                    <mat-label>Nom</mat-label>
                    <input matInput data-input-name type="text" formControlName="name" autocomplete="off" required />
                    @if (formGroupErrors?.name?.required && (formGroup.controls['name']?.dirty || formGroup.controls['name'].touched)) {
                        <mat-error data-input-title-error>Le champ 'Nom' est obligatoire</mat-error>
                    }
                </mat-form-field>
                <fa-icon [icon]="faCircleInfo" class="info-icon" matTooltip="Nom de la mise en page" matTooltipPosition="right"></fa-icon>
            </div>
            <div class="form-item form-item-help">
                <mat-checkbox class="with-info-icon accent-button" formControlName="isScreenSizeAdapted">La taille des colonnes s'adapte à la largeur de l'écran.</mat-checkbox>
                <fa-icon
                    [icon]="faCircleInfo"
                    class="info-icon"
                    matTooltip="Si cette option est cochée, les largeurs de colonnes seront définies en % afin de permettre l'affichage de la liste sans barre de défilement horizontale. Si cette option est décochée, les largeurs de colonnes seront définies en pixels. Dans le cas où la liste serait plus large que l'écran , une barre de défilement horizontale permettra de se déplacer dans la liste."
                    matTooltipPosition="right"></fa-icon>
            </div>
            <div class="form-item form-item-help">
                <mat-form-field class="with-info-icon">
                    <mat-label>Nombre d’enregistrements par page</mat-label>
                    <input matInput data-input-workflowStepColumnWidth type="number" formControlName="recordsPerPage" autocomplete="off" />
                    @if (formGroup.get('recordsPerPage').hasError('min')) {
                        <mat-error>La valeur minimum est 50</mat-error>
                    }
                </mat-form-field>
                <fa-icon
                    [icon]="faCircleInfo"
                    class="info-icon"
                    matTooltip="Plus le nombre est grand et moins il sera nécessaire de faire des requêtes serveurs lors du défilement. Par contre le temps de réponse pour charger la liste sera plus important."
                    matTooltipPosition="right"></fa-icon>
            </div>
        </div>
    </form>
    <div class="buttons-container">
        <button mat-stroked-button class="accent-button" [disabled]="formGroup.disabled" [ngClass]="{ disabled: formGroup.invalid || formGroup.disabled }" (click)="cancel()">
            Annuler
        </button>
        <button
            mat-raised-button
            class="accent-button"
            [disabled]="formGroup.disabled || formGroup.invalid"
            [ngClass]="{ disabled: formGroup.invalid || formGroup.disabled }"
            (click)="manualSave()">
            Enregistrer
        </button>
    </div>
</div>
